// CMS Sync Status Component
// Displays CMS synchronization history

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Database, CheckCircle, AlertCircle, Link2 } from 'lucide-react';

const CMSSyncStatus = ({ cmsSyncs }) => {
  if (!cmsSyncs || cmsSyncs.length === 0) return null;

  return (
    <Card className="border-slate-200" data-testid="cms-sync-status-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg" style={{ fontFamily: 'Manrope, sans-serif' }}>
          <Database className="w-5 h-5 text-teal-500" />
          CMS Sync
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {cmsSyncs.map((sync, index) => (
          <div 
            key={index}
            className={`p-3 rounded-lg border ${
              sync.success 
                ? 'bg-emerald-50 border-emerald-200' 
                : 'bg-red-50 border-red-200'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {sync.success ? (
                  <CheckCircle className="w-4 h-4 text-emerald-600" />
                ) : (
                  <AlertCircle className="w-4 h-4 text-red-600" />
                )}
                <span className={`font-medium text-sm capitalize ${
                  sync.success ? 'text-emerald-800' : 'text-red-800'
                }`}>
                  {sync.cms_type}
                </span>
              </div>
              {sync.auto_synced && (
                <span className="text-xs bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded">
                  Auto
                </span>
              )}
            </div>
            <p className={`text-xs mt-1 ${sync.success ? 'text-emerald-600' : 'text-red-600'}`}>
              {sync.success ? 'Synced successfully' : sync.errors?.join(', ') || 'Sync failed'}
            </p>
            {sync.cms_record_url && (
              <a 
                href={sync.cms_record_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-xs text-teal-600 hover:text-teal-700 mt-2"
              >
                <Link2 className="w-3 h-3" />
                View in CMS
              </a>
            )}
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default CMSSyncStatus;
